import type { InputMask } from 'imask';

import { fetchImask } from '../dynamic-modules';

const map = new WeakMap<Element, InputMask<any>>();
export const thousandsSeparator = ' ';

function getInstanceByElement(element: Element) {
    return map.get(element);
}

export async function initNumberMasks(container: Element | Document = document) {
    const elements = Array.from(
        container.querySelectorAll<HTMLInputElement>('input[data-mask="number"]:not(.mask--initialized)'),
    );

    if (elements.length > 0) {
        const { default: IMask } = await fetchImask();

        elements.forEach((el) => {
            const imask = IMask(el, {
                mask: Number,
                min: el.dataset.min ? parseFloat(el.dataset.min) : -Infinity,
                max: el.dataset.max ? parseFloat(el.dataset.max) : Infinity,
                thousandsSeparator,
                scale: el.dataset.maskScale ? parseInt(el.dataset.maskScale, 10) : 2,
            });
            map.set(el, imask);
            el.classList.add('mask--initialized');
        });
    }
}

export async function initPhoneMask(input: HTMLInputElement, dialCode = '7') {
    const { default: IMask } = await fetchImask();
    // const getMask = (_dialCode: string) => `+{${_dialCode}} (000) 000-00-00`;
    // const imask = IMask(input, { mask: getMask(dialCode) });
    // const imask = IMask(input, { mask: /^(?=.*[0-9])[- +()0-9]+$/ });
    const imask = IMask(input, { mask: /[- +()0-9]+$/ });
    map.set(input, imask);
    input.classList.add('mask--initialized');
}

export async function destroyPhoneMask(input: HTMLInputElement) {
    const imask = getInstanceByElement(input);
    if (imask) {
        imask.destroy();
        map.delete(input);
        input.classList.remove('mask--initialized');
    }
}

async function initPhoneMasks(container: Element | Document = document) {
    const elements = Array.from(
        container.querySelectorAll('input[data-mask="phone"]:not(.mask--initialized)'),
    ) as HTMLInputElement[];

    if (elements.length > 0) {
        await fetchImask();
        elements.forEach((el) => {
            initPhoneMask(el);
        });
    }
}

async function initCodeMasks(container: Element | Document = document) {
    const elements = Array.from(
        container.querySelectorAll('input[data-mask="code"]:not(.mask--initialized)'),
    ) as HTMLInputElement[];

    if (elements.length > 0) {
        const { default: IMask } = await fetchImask();

        elements.forEach((el) => {
            const imask = IMask(el, { mask: '0' });
            map.set(el, imask);
            el.classList.add('mask--initialized');
        });
    }
}

async function initIndexMasks(container: Element | Document = document) {
    const elements = Array.from(
        container.querySelectorAll('input[data-mask="index"]:not(.mask--initialized)'),
    ) as HTMLInputElement[];

    if (elements.length > 0) {
        const { default: IMask } = await fetchImask();

        elements.forEach((el) => {
            const imask = IMask(el, {
                mask: Number,
                min: el.dataset.min ? parseFloat(el.dataset.min) : -Infinity,
                max: el.dataset.max ? parseFloat(el.dataset.max) : Infinity,
            });
            map.set(el, imask);
            el.classList.add('mask--initialized');
        });
    }
}

async function initINNMasks(container: Element | Document = document) {
    const elements = Array.from(
        container.querySelectorAll('input[data-mask="inn"]:not(.mask--initialized)'),
    ) as HTMLInputElement[];

    if (elements.length > 0) {
        const { default: IMask } = await fetchImask();

        elements.forEach((el) => {
            const imask = IMask(el, {
                mask: Number,
                min: el.dataset.min ? parseFloat(el.dataset.min) : -Infinity,
                max: el.dataset.max ? parseFloat(el.dataset.max) : Infinity,
            });
            map.set(el, imask);
            el.classList.add('mask--initialized');
        });
    }
}

function init(container: Element | Document = document) {
    initNumberMasks(container);
    initPhoneMasks(container);
    initCodeMasks(container);
    initIndexMasks(container);
    initINNMasks(container);
}

function destroy(container: Element | Document = document) {
    const elements = Array.from(container.querySelectorAll('input[data-mask]')) as HTMLInputElement[];
    elements.forEach((el) => {
        destroyPhoneMask(el);
    });
}

const _module = { init, destroy, getInstanceByElement };

export default _module;
